import React from "react";
import {
    Spin,
    Divider,
    Row,
    Col
} from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "../DashboardEstablecimiento/Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoTotalVentasTipoComprobante from "./GraficoTotalVentasTipoComprobante";
import GraficoCantidadComprobanteTipoComprobante from "./GraficoCantidadComprobanteTipoComprobante";
import GraficoTotalVentasMensual from "./GraficoTotalVentasMensual";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            anios: anioMock.values,
            meses: mesMock.values,
            filter: {
                anioInicio: global.fetchCurrentYear(true),
                mesInicio: global.fetchCurrentMonth(true),
                anioFin: global.fetchCurrentYear(),
                mesFin: global.fetchCurrentMonth()
            },
            graficoTotalVentasMensual: {
                series: [],
                timeLine: [],
            },
            graficoTotalVentasTipoComprobante: {
                series: [],
                establecimientos: [],
            },
            graficoCantidadComprobanteTipoComprobante: {
                series: [],
                establecimientos: [],
            },
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleClearFilters = () => {
        this.setState({
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
        });
    };

    handleGenerateReport = async (filter) => {
        this.setState({
            loading: true,
        });
        const response = await comprobanteService.dashboardEstablecimiento(filter);
        if (response !== undefined)
            this.setState({
                graficoTotalVentasTipoComprobante: {
                    series: response.dataGraficoTotalVentasTipoComprobante,
                    establecimientos: response.dataEstablecimientoOrderTotal,
                },
                graficoCantidadComprobanteTipoComprobante: {
                    series: response.dataGraficoCantidadComprobanteTipoComprobante,
                    establecimientos: response.dataEstablecimientoOrderCantidad,
                },
                graficoTotalVentasMensual: {
                    series: response.dataGraficoTotalVentasMensual,
                    timeLine: response.dataTimeLine,
                },
                loading: false
            });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
        this.setState({
            loading: false,
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Dashboard de Ventas por Establecimiento"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <Row gutter={50}>
                        <Col className="gutter-row" sm={24} md={24} lg={24} xl={12}>
                            <GraficoTotalVentasTipoComprobante
                                series={this.state.graficoTotalVentasTipoComprobante.series}
                                establecimientos={this.state.graficoTotalVentasTipoComprobante.establecimientos}
                            />
                        </Col>
                        <Col className="gutter-row" sm={24} md={24} lg={24} xl={12}>
                            <GraficoCantidadComprobanteTipoComprobante
                                series={this.state.graficoCantidadComprobanteTipoComprobante.series}
                                establecimientos={this.state.graficoCantidadComprobanteTipoComprobante.establecimientos}
                            />
                        </Col>
                    </Row>
                    <Divider className="mb-20" />
                    <Row gutter={16}>
                        <Col className="gutter-row" sm={24} md={24} lg={24}>
                            <GraficoTotalVentasMensual
                                series={this.state.graficoTotalVentasMensual.series}
                                timeLine={this.state.graficoTotalVentasMensual.timeLine}
                            />
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
